import { createSelector } from '@reduxjs/toolkit';
import { entityFieldDescriptions, entityTypeVerboseNames } from './dictionaries';

export const addExecutorForm = createSelector(
  entityFieldDescriptions,
  entityTypeVerboseNames,
  (entityFieldDescriptions, entityTypeVerboseNames) => ({ entityFieldDescriptions, entityTypeVerboseNames }),
);
